module.exports = __webpack_public_path__ + "img/size7.434251e7.png";